<template>
  <tr
    :key="row.id"
    :class="['table-row', `table-row-${index}`]"
    :data-qa="`table-row-${index}`">
    <td
      v-for="header in headers"
      :key="header.value + index"
      class="text-start table-row__td"
      :class="[header.value + '-td' , header.cellClass || '', {'disabled': disabled}]"
      :data-qa="'td' + header.value"
      :style="`width: ${header.width}; ${!load ? 'padding: 12px 16px 12px !important' : ''}; ${header.fixed ? 'z-index: 1;position: sticky; right: 0;' : ''}`">
      <template v-if="!load">
        <template v-if="header.value == 'name' || header.value == 'lotSubject'">
          {{ index }}
        </template>
        <template v-if="row_sync[header.value]">
          {{ row_sync[header.value] }}
        </template>
      </template>
      <template v-else>
        <template v-if="header.value == 'data-table-select'">
          <div class="flex width-100 height-100">
            <sCheckbox
              class="mx-auto my-auto"
              :data-qa="`table-row-${index}-check`"
              :disable="disabled || header.disable"
              :value="isCheck"
              @input="$emit('check', row)"/>
          </div>
        </template>
        <!-- Наименование -->
        <template v-if="header.value == 'name'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-name`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].name`"/>
          <ResourceName
            class="pl-6 py-3"
            :item="row_sync"/>
        </template>
        <!-- Наименование лота -->
        <template v-if="header.value == 'lotSubject'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-lotSubject`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].lotSubject`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-lotSubject`"
            :disable="disabled || header.disable"
            :value="row_sync.lotSubject || row_sync.lotNumber || row_sync.id">
            <template #editor="{ deactivate }">
              <CustomTextarea
                area_class_name="textarea pb-1 pt-1 pl-6 pr-4 h7-text "
                autofocus
                clear_icon="cancel"
                clearable
                data-qa="lotSubject-edit"
                debounce
                max_length="4000"
                rows="1"
                :rule-function="checkDescr(4000)"
                show_details_focused
                :value="row_sync.lotSubject"
                @action="changeField ? changeField : null"
                @blur="change(deactivate)"
                @keydown_enter="change(deactivate)"
                @keydown_esc="change(deactivate)"
                @update:value="changeProp('lotSubject', $event)"/>
            </template>
            <template #activator="{ activate }">
              <div
                class="pl-6 pr-4 py-3 flex flex-wrap flex-direction-column flex-grow-1"
                @click="activate">
                <div
                  v-if="row_sync.category"
                  class="pl-0 font-size-12 opacity-7">
                  {{ row_sync.codeCpv }} {{ row_sync.category.name }}
                </div>
                #{{ row_sync.lotNumber || row_sync.id }}
                {{ row_sync.lotSubject }}
              </div>
            </template>
          </HoverAddData>
        </template>
        <!-- Описание -->
        <template v-if="header.value == 'description'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-description`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].description`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-description`"
            :disable="disabled || header.disable"
            :label="$t('Common.AddDescription')"
            :value="row_sync.description">
            <template #editor="{ deactivate }">
              <CustomTextarea
                area_class_name="textarea pb-1 pt-1 pl-6 pr-4 h7-text "
                autofocus
                clear_icon="cancel"
                clearable
                max_length="4000"
                rows="1"
                :rule-function="checkDescr(4000)"
                show_details_focused
                :value="row_sync.description"
                @blur="deactivate"
                @keydown_enter="deactivate"
                @keydown_esc="deactivate"
                @update:value="changeProp('description', $event)"/>
            </template>
          </HoverAddData>
        </template>
        <!--Одиниця вимірювання-->
        <template v-if="header.value == 'measuringUnit'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-description`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].measuringUnit`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-measuringUnit`"
            :disable="disabled || header.disable"
            :label="$t('Common.Add')"
            :value="measure">
            <template #editor="{ deactivate }">
              <sSelect
                auto-open
                automatic-dropdown
                class="my-2 mx-2"
                filterable
                placeholder=""
                transparent
                :value="row_sync.measuringUnit"
                @close="deactivate"
                @update:value="changeProp('measuringUnit', $event)">
                <template v-if="isTopMeasure && groupsMeasurements && groupsMeasurements.topMeasurements && groupsMeasurements.topMeasurements.length">
                  <sOptionGroup
                    key="top-5"
                    :label="$t('Common.top5')">
                    <sOption
                      v-for="(topMeasurement, measurementIndex) in groupsMeasurements.topMeasurements"
                      :key="topMeasurement.unitCode + '-' + measurementIndex + '-1'"
                      class="flex flex-between"
                      :label="topMeasurement.unitFilter"
                      :value="topMeasurement.unitCode">
                      <span>{{ topMeasurement.unitTitleLower }}</span>
                      <span class="opacity-7 font-size-12">{{ topMeasurement.unitShortTitleLower }}</span>
                    </sOption>
                  </sOptionGroup>
                  <sOptionGroup key="other">
                    <sOption
                      v-for="(measurement, measurementIndex) in groupsMeasurements.measurements"
                      :key="measurement.unitCode + '-' + measurementIndex + '-2'"
                      class="flex flex-between"
                      :label="measurement.unitFilter"
                      :value="measurement.unitCode">
                      <span>{{ measurement.unitTitleLower }}</span>
                      <span class="opacity-7 font-size-12">{{ measurement.unitShortTitleLower }}</span>
                    </sOption>
                  </sOptionGroup>
                </template>
                <template v-else>
                  <sOption
                    v-for="(measurement, measurementIndex) in groupsMeasurements.measurements"
                    :key="measurement.unitCode + '-' + measurementIndex + '-3'"
                    class="flex flex-between"
                    :label="measurement.unitFilter"
                    :value="measurement.unitCode">
                    <span>{{ measurement.unitTitleLower }}</span>
                    <span class="opacity-7 font-size-12">{{ measurement.unitShortTitleLower }}</span>
                  </sOption>
                </template>
              </sSelect>
            </template>
          </HoverAddData>
        </template>
        <!-- Дата поставки -->
        <template v-if="header.value == 'declaredSupplyDate'">
          <sFormItem
            v-if="row_sync.declaredSupplyDate"
            :data-qa="`table-row-${index}-valid-declaredSupplyDate`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].declaredSupplyDate`"/>
          <sFormItem
            v-else
            :data-qa="`table-row-${index}-valid-declaredPriority.id`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].declaredPriority.id`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-supplyDate`"
            :disable="disabled || header.disable"
            :formatter="formatAppDateTo"
            :label="$t('Common.AddDate')"
            menu
            :text_class="check_wrong_date ? 'secondary__red--text' : '' "
            :value="row_sync.declaredPriority.id || row_sync.declaredSupplyDate"
            with_common_class>
            <template #menu="{ deactivate }">
              <DateCell
                :item="row_sync"
                :items="positions_sync"
                @fieldsChange="change(deactivate)"/>
            </template>
          </HoverAddData>
        </template>
        <!-- Количество в заявках-->
        <template v-if="header.value == 'declaredQuantity'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-declaredQuantity`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].declaredQuantity`"/>
          <v-row
            class="flex-nowrap declaredQuantity"
            no-gutters>
            <HoverAddData
              :data-qa="`table-row-${index}-declaredQuantity`"
              :disable="disabled || header.disable"
              :formatter="formatNumber"
              :label="$t('Common.Add')"
              :suffix="!useUnitCol && row_sync.unit && row_sync.unit.name ? row_sync.unit.name.trim() : ''"
              :value="row_sync.declaredQuantity">
              <template #editor="{ deactivate }">
                <v-text-field
                  ref="declaredQuantity"
                  auto-grow
                  autofocus
                  class="quantity textarea h7-text py-1 pl-6 pr-3 "
                  color="var(--black-color)"
                  height="40"
                  hide-details
                  rounded
                  :value="row_sync.declaredQuantity"
                  @blur="deactivate"
                  @change="change(deactivate)"
                  @input="value => check('declaredQuantity', value, 'declaredQuantity')"
                  @keydown.enter="deactivate"
                  @keydown.esc="deactivate"
                  @keypress="isNumber($event)">
                  <template #append>
                    <sButton
                      class="mr-1"
                      icon="cancel"
                      small
                      type="text"
                      @click="row_sync.declaredQuantity = 0"/>
                  </template>
                </v-text-field>
                <div
                  v-if="tenderingForPercentage"
                  :data-qa="`table-row-${index}-declaredQuantity-percent`">
                  %
                </div>
                <div
                  v-else-if="row_sync.declaredQuantity"
                  class="measur d-flex align-center mr-2"
                  :data-qa="`table-row-${index}-declaredQuantity-unit`">
                  {{ row_sync.unit && row_sync.unit.name ? row_sync.unit.name.trim() : '' }}
                </div>
              </template>
            </HoverAddData>
            <div v-if="tenderingForPercentage">
              %
            </div>
            <div
              v-else-if="!row_sync.declaredQuantity"
              class="measur d-flex align-center mr-2">
              {{ row_sync.unit && row_sync.unit.name ? row_sync.unit.name.trim() : '' }}
            </div>
          </v-row>
        </template>
        <!-- Количество в тендери-->
        <template v-if="header.value == 'quantity'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-quantity`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].quantity`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-quantity`"
            :disable="disabled || header.disable"
            :formatter="formatNumber"
            :label="$t('Common.Add')"
            :suffix="useUnitCol ? '' : measure"
            :value.sync="row_sync.quantity">
            <template #editor="{ deactivate }">
              <v-text-field
                ref="quantity"
                auto-grow
                autofocus
                class="quantity textarea py-1 pl-6 pr-3 h7-text"
                color="var(--black-color)"
                hide-details
                rounded
                :value="row_sync.quantity"
                @blur="deactivate"
                @change="change(deactivate)"
                @input="value => check('quantity', value, 'quantity', 3)"
                @keydown.enter="deactivate"
                @keydown.esc="deactivate"
                @keypress="isNumber($event)">
                <template #append>
                  <sButton
                    class="mr-1"
                    icon="cancel"
                    small
                    type="text"
                    @click="row_sync.quantity = 0"/>
                </template>
              </v-text-field>
            </template>
          </HoverAddData>
        </template>
        <!-- Минимальное количество -->
        <template v-if="header.value==='minimalSubmitQuantity'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-minimalSubmitQuantity`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].minimalSubmitQuantity`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-minimalSubmitQuantity`"
            :disable="disabled || header.disable"
            :formatter="formatNumber"
            :label="$t('Common.Add')"
            :value.sync="row_sync.minimalSubmitQuantity">
            <template #editor="{ deactivate }">
              <v-text-field
                ref="minimalSubmitQuantity"
                auto-grow
                autofocus
                class="minimalSubmitQuantity textarea py-1 pl-6 pr-3  h7-text"
                color="var(--black-color)"
                hide-details
                rounded
                :value="row_sync.minimalSubmitQuantity"
                @blur="deactivate"
                @change="change(deactivate)"
                @input="value => check('minimalSubmitQuantity', value, 'minimalSubmitQuantity')"
                @keydown.enter="deactivate"
                @keydown.esc="deactivate"
                @keypress="isNumber($event)">
                <template #append>
                  <sButton
                    class="mr-1"
                    icon="cancel"
                    small
                    type="text"
                    @click="row_sync.minimalSubmitQuantity = 0"/>
                </template>
              </v-text-field>
            </template>
          </HoverAddData>
        </template>
        <!-- Цена -->
        <template v-if="header.value == 'price'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-price`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].price`"/>
          <HoverAddData
            :disable="disabled || header.disable"
            :formatter="formatNumber"
            :label="$t('Common.Add')"
            :suffix="getCurrencyName(item, row_sync.price)"
            :value="row_sync.price">
            <template #editor="{ deactivate }">
              <v-text-field
                ref="price"
                auto-grow
                autofocus
                class="price textarea h7-text py-1 pl-6 pr-3  "
                color="var(--black-color)"
                height="40"
                hide-details
                rounded
                :value="row_sync.price"
                @blur="deactivate"
                @change="change(deactivate)"
                @input="value => check('price', value, 'price')"
                @keydown.enter="deactivate"
                @keydown.esc="deactivate"
                @keypress="isNumber($event)">
                <template #append>
                  <sButton
                    class="mr-1"
                    icon="cancel"
                    small
                    type="text"
                    @click="row_sync.price = 0"/>
                </template>
              </v-text-field>
            </template>
          </HoverAddData>
        </template>
        <!-- Начальная ставка -->
        <template v-if="header.value == 'startAmount'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-startAmount`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].startAmount`"/>
          <HoverAddData
            :disable="disabled || header.disable"
            :formatter="formatNumberWithPriceRounding"
            :label="$t('Common.Add')"
            :suffix="tenderingForPercentage ? '%' : currency"
            :value.sync="row_sync.startAmount">
            <template #editor="{ deactivate }">
              <v-text-field
                ref="startAmount"
                auto-grow
                autofocus
                class="price textarea py-1 pl-6 pr-3  h7-text"
                color="var(--black-color)"
                hide-details
                rounded
                :value="row_sync.startAmount"
                @blur="deactivate"
                @change="change(deactivate)"
                @input="value => checkStartAmount('startAmount', value, 'startAmount')"
                @keydown.enter="deactivate"
                @keydown.esc="deactivate"
                @keypress="isNumber($event)">
                <template #append>
                  <sButton
                    class="mr-1"
                    icon="cancel"
                    small
                    type="text"
                    @click="clearStartAmount(row_sync)"/>
                </template>
              </v-text-field>
            </template>
          </HoverAddData>
        </template>

        <!-- Мінімальна ціна -->
        <template v-if="header.value == 'bidPriceLimit'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-bidPriceLimit`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].bidPriceLimit`"/>

          <HoverAddData
            :disable="disabled || header.disable"
            :formatter="formatNumberWithPriceRounding"
            :label="$t('Common.Add')"
            :suffix="tenderingForPercentage ? '%' : currency"
            :value.sync="row_sync.bidPriceLimit">
            <template #editor="{ deactivate }">
              <v-text-field
                ref="bidPriceLimit"
                auto-grow
                autofocus
                class="price textarea py-1 pl-6 pr-3  h7-text"
                color="var(--black-color)"
                hide-details
                rounded
                :value="row_sync.bidPriceLimit"
                @blur="deactivate"
                @change="change(deactivate)"
                @input="value => checkBidPriceLimit('bidPriceLimit', value, 'bidPriceLimit')"
                @keydown.enter="deactivate"
                @keydown.esc="deactivate"
                @keypress="isNumber($event)">
                <template #append>
                  <sButton
                    class="mr-1"
                    icon="cancel"
                    small
                    type="text"
                    @click="clearBidPriceLimit(row_sync)"/>
                </template>
              </v-text-field>
            </template>
          </HoverAddData>
        </template>


        <!-- Шаг торгов -->
        <template v-if="header.value == 'bidStep'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-bidStep`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].bidStep`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-bidStep`"
            :disable="disabled || header.disable"
            :label="$t('Common.Add')"
            menu
            text_class="py-3 pl-6 pr-3 "
            :value="row_sync.bidStep"
            with_common_class>
            <template #activator>
              <v-tooltip
                bottom
                content-class="tooltip black--text">
                <template #activator="{ on }">
                  <span
                    :class="{'text-error' : check_step }"
                    v-on=" check_step ? on : ''">
                    {{ bid_step }}
                    <template v-if="tenderingForPercentage">%</template>
                    <template v-else>{{ tender && tender.bidStepType ? currency : '%' }}</template>
                  </span>
                </template>
                {{ tender && tender.bidStepType ? $t('Tenders.BiddingStepMoreThanStartingPrice')
                  : $t('Tenders.BiddingStepMoreOrLess', {max: max_step, min: min_step}) }}
              </v-tooltip>
            </template>
            <template #menu="{ deactivate, activ }">
              <ChangeStepMenu
                :activ.sync="activ"
                :item="row_sync"
                :step="row_sync.bidStep"
                step_key="bidStep"
                :tender.sync="tender"
                @change="item => setStep(item, deactivate)"/>
            </template>
          </HoverAddData>
        </template>
        <!-- Адрес поставки -->
        <template v-if="header.value == 'addressId'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-addressId`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].addressId`"/>
          <HoverAddData
            :data-qa="`table-row-${index}-addressId`"
            :disable="disabled || header.disable"
            :label="$t('Common.Add')"
            left
            menu
            :value.sync="address">
            <template #menu="{ deactivate, activ }">
              <ChangeLotAddres
                :activ.sync="activ"
                :addresses="addresses || []"
                :item="row_sync"
                :lots.sync="positions_sync"
                @change="deactivate"/>
            </template>
          </HoverAddData>
        </template>
        <!-- Сумма -->
        <template v-if="header.value == 'summ'">
          <sFormItem
            :data-qa="`table-row-${index}-valid-summ`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].summ`"/>
          <v-row
            class="pl-6 pr-3"
            no-gutters>
            <div
              v-if="row_sync.startAmount || !isTender"
              class="flex flex-wrap align-center">
              {{ summValue }}
              <template v-if="isTender">
                {{ currency }}
              </template>
              <template v-else>
                {{ $tc(`Common.currency.${item.currency.id}`, summValue) }}
              </template>
            </div>
          </v-row>
        </template>
        <!-- Сумма пошаговая (лесница) -->
        <template v-if="header.value == 'discounts'">
          <sFormItem
            :data-qa="`table-row-${index}-price-with-discount`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].discounts`"/>
          <TenderDiscounts
            :options="{currency: currency, measure: measure}"
            :value.sync="row_sync"/>
        </template>
        <template v-if="header.value == 'menu' || header.value == 'menuWithAdditionalField'">
          <RowMenu
            class-name="ml-2"
            :disable-clone="tender && tender.biddingType && tender.biddingType.onlyOneLotPerTender && positions_sync.length"
            :disabled="disabled || (tender && tender.createdByExternalApi)"
            @cancelSelection="$emit('cancelSelection')"
            @copyItem="$emit('copyItem')"/>
        </template>
        <template v-if="header.value == 'delete'">
          <sButton
            v-if="deleteLot"
            :disabled="disabled"
            icon="cancel"
            icon-size="16px"
            small
            type="text"
            @click="deleteLot(row_sync)"/>
        </template>
        <template v-if="header.value && header.value.includes(newDesign ? 'additional_fields' : 'AdditionalFields')">
          <sFormItem
            :data-qa="`table-row-${index}-${header.value}`"
            mode="table-cell"
            :prop="`${validatePropPrefix}[${index}].${header.value}${newDesign ? '.value' : ''}`"/>
          <AdditionalFieldTd
            :disable="disabled || header.disable"
            :header="header"
            :index="index"
            :positions.sync="positions_sync"
            :row.sync="row_sync"
            @changeField="change"/>
        </template>
      </template>
    </td>
  </tr>
</template>
<script>
import RowMenu from 'components/common/blocks/RowMenu.vue'
import ResourceName from 'components/purchasing/ResourceName.vue'
import TenderDiscounts from 'components/tenders/TenderDiscounts.vue'
import HoverAddData from 'components/common/blocks/HoverAddData.vue'
import DateCell from 'components/purchasing/new purchase/DateCell.vue'
import CustomTextarea from 'components/common/inputs/CustomTextarea.vue'
import ChangeStepMenu from 'components/tenders/tender creation/ChangeStepMenu.vue'
import AdditionalFieldTd from 'components/additional fields/AdditionalFieldTd.vue'
import ChangeLotAddres from 'components/tenders/tender creation/ChangeLotAddres.vue'

/* eslint-disable vue/no-mutating-props */
import { filterSortMixin, measureMixin, modalMixin } from 'mixins'
import { mapGetters } from 'vuex'

/**
 * строки таблиц.
 * тендеры/заявки
 */
export default {
  mixins: [filterSortMixin, measureMixin, modalMixin],
  name: 'editRowTr',
  data() {
    return {
      load: false,
      observer: null,
      all_mode: false
    }
  },
  props: {
    row: Object,
    headers: Array,
    index: Number,
    /**
     * об'єкт заявки/тендера
     */
    item: Object,
    /**
     * конкретно тендер
     */
    tender: {
      type: Object,
      default: () => {}
    },
    deleteLot: Function,
    /**
     * Префикс для свойства валидации
     */
    validatePropPrefix: {
      type: String,
      default: ''
    },
    /**
     * позиції які будуть відображатись
     */
    positions: Array,
    /**
     * рядки з заявки
     */
    rows: Array,
    /**
     * валюта для тендера
     */
    currency: String,
    /**
     * валідація позицій
     */
    changeField: Function,
    /**
     * чи показується рядок на екрані або чи пора починати розрахунки
     */
    loaded: {
      type: Boolean,
      default: true
    },
    additional_fields: {
      type: Array,
      default: () => []
    },
    newDesign: Boolean,
    disabled: Boolean,
    selected: {
      type: Array,
      default: () => []
    }, // массик ключей всех выделенных строк
  },
  mounted() {
    let options = {
      root: document.querySelector('.main_container'),
      rootMargin: '200px',
      threshold: 0.2
    }
    this.observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        if (element.isIntersecting && !this.load) {
          this.observer.unobserve(element.target)
          this.observer = null
        }
        this.load ||= element.isIntersecting
      })
    }, options)
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    if (this.observer && !this.load) {
      this.observer.unobserve(this.$el)
    }
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
    }),
    isCheck() {
      return this.selected.includes(this.row.lotNumber)
    },
    positions_sync: {
      get() {
        return this.positions
      },
      set(newValue) {
        this.$emit('update:rows', newValue)
      }
    },
    useUnitCol() {
      return !!this.headers.find(i => i.value == 'measuringUnit')
    },
    isTender() {
      return !!this.tender
    },
    summValue() {
      if (this.isTender) {
        return this.formSum(this.normalizeNum(this.row_sync.quantity) * this.normalizeNum(this.row_sync.startAmount))
      }
      return (this.row_sync.price || 0) * (this.row_sync.declaredQuantity || 0)
    },
    row_sync: {
      get() {
        return this.row
      },
      set(value) {
        this.$emit('update:row', value)
      }
    },
    tenderingForPercentage() {
      return this.tender?.biddingType?.tenderingForPercentage
    },
    addresses() {
      return this.$store.getters.getSupplierAddress || []
    },
    measure() {
      return this.getMeasure(this.row_sync)
    },
    bid_step() {
      return this.formatNumber(this.row_sync.bidStep)
    },
    app_summa() {
      return this.row_sync.summa || this.sum(this.row_sync, true)
    },
    address() {
      let id = this.row_sync.id,
        address = this.addresses?.find(el => id == el.supplierAddressId)
      if (address) {
        return  (address.postalCode || '') + ' ' + this.$t('Common.City') + ' ' + address.city + ' ' +  address.street
      } else if (this.rows) {
        return this.rows.find(item => item.receiver?.id == id)?.receiver?.name || id
      } else {
        return id
      }
    },
    min_step() {
      return this.tendersSettings?.minBidStep
    },
    max_step() {
      return this.tendersSettings?.maxBidStep
    },
    check_step() {
      return this.tender?.bidStepType ?
        this.row_sync.startAmount && (this.row_sync.startAmount / 2) < this.row_sync.bidStep :
        this.row_sync.bidStep > this.max_step || this.row_sync.bidStep < this.min_step
    },
    check_wrong_date() {
      return this.row_sync.declaredSupplyDate
        && this.$moment(this.row_sync.declaredSupplyDate).format('YYYY-MM-DD') < this.$moment().format('YYYY-MM-DD')
    },
  },
  methods: {
    formatNumberWithPriceRounding(value) {
      const digits = this.tendersSettings?.priceRoundingDigit ?? 2
      return this.$formatPrice(value, digits)
    },
    clearStartAmount() {
      this.row_sync.startAmount = 0
      this.check('startAmount', 0, 'startAmount')
    },
    clearBidPriceLimit() {
      this.row_sync.bidPriceLimit = 0
      this.check('bidPriceLimit', 0, 'bidPriceLimit')
    },
    changeProp(prop, value) {
      const result = this.$_.cloneDeep(this.row_sync)
      result[prop] = value
      this.row_sync = result
    },
    isNumber(evt) {
      let keyCode = (evt.keyCode ? evt.keyCode : evt.which)

      let correct = false
      const amount = (evt.srcElement.value || 0).toString()
      if (keyCode >= 48 && keyCode <= 57) {
        /* Только цифры */
        correct = true

      } else if (String.fromCharCode(keyCode) === '.' || String.fromCharCode(keyCode) === ',') {
        /* пропускаем разделитель, если его еще не ввели */
        const indexDot = amount.indexOf('.')
        const indexComa = amount.indexOf(',')
        correct = !amount || (amount && indexDot == -1 && indexComa == -1)
      } else if (keyCode === 45) {
        /* пропускаем минус, если его еще не ввели */
        correct = !amount || (amount && amount.indexOf('-') == -1)
      }

      if (!correct) {
        evt.preventDefault()
      }
    },
    setStep(value, deactivate) {
      this.tender.bidStepType = value.type
      this.$emit('changeBidType', value.type)

      const positions = this.$_.cloneDeep(this.positions)
      if (value.allLot) {
        positions.forEach(el => {
          el.bidStep = value.value
        })
      } else {
        positions[this.index].bidStep = value.value
      }
      this.positions_sync = positions

      this.change(deactivate)
    },
    formatAdditinalField(field) {
      const typeId = field?.typeId || field?.type?.typeId
      return typeId == 'DATE_TIME' ? this.formatBy(field?.value, 'DD.MM.YYYY') : field?.value
    },
    checkDescr(length) {
      if (!length) {
        length = 254
      }
      this.row_sync.description = this.row_sync.description?.substring(0, length) ?? ''
    },
    change(deactivate) {
      this.checkFields()
      if (deactivate && typeof deactivate == 'function') {
        deactivate()
      }

      this.changeField && this.changeField()
      this.$forceUpdate()
    },
    checkFields() {
      let item = this.row_sync
      if (this.tender) {
        item.quantity = +this.$_formatValue(item.quantity || 0)
        item.minimalSubmitQuantity = +this.$_formatValue(item.minimalSubmitQuantity || 0)
        item.startAmount = +this.$_formatValue(item.startAmount || 0)
        item.bidPriceLimit = +this.$_formatValue(item.bidPriceLimit  || 0)
      } else {
        item.declaredQuantity = +this.$_formatValue(item.declaredQuantity  || 0)
        item.price = +this.$_formatValue(item.price  || 0)
      }
    },
    check(type, inputValue, refName, decimalPlaces = null) {
      inputValue = inputValue + ''
      inputValue = inputValue.replace(/[^,.\d]/g, '')
      let item = this.$_.cloneDeep(this.row_sync)

      item[type] = this.normalizeNum(inputValue)

      let ref = this.$refs[refName]

      const digits = decimalPlaces !== null ? decimalPlaces : (ref ? 2 : 3)

      this.sliceText(item[type],
        ref,
        digits,
        val => {
          const numberFields = ['quantity', 'minimalSubmitQuantity', 'startAmount', 'bidStep', 'bidPriceLimit']
          if (numberFields.includes(type)) {
            item[type] = Number(val) || 0
          } else {
            item[type] = val
          }
        })

      this.row_sync = item
    },
    checkStartAmount(type, inputValue, refName) {
      this.check(type, inputValue, refName, this.tendersSettings.priceRoundingDigit ?? 2)
    },
    checkBidPriceLimit(type, inputValue, refName) {
      this.check(type, inputValue, refName, this.tendersSettings.priceRoundingDigit ?? 2)
    }
  },
  components: {
    RowMenu,
    DateCell,
    ResourceName,
    HoverAddData,
    ChangeStepMenu,
    CustomTextarea,
    ChangeLotAddres,
    TenderDiscounts,
    AdditionalFieldTd
  }
}
</script>
<style scoped lang="scss">
.table-row:last-child {
  .table-row__td {
    /*&>* {
      display: table-cell;
    }*/
    &:first-child.sForm-cell-error {
      border-radius: 0 0 0 12px;
    }
    &:last-child.sForm-cell-error {
      border-radius: 0 0 12px 0;
    }
  }
}
</style>
